class AdaptiveBucketPolicyService {

    public static base_url: string = import.meta.env.VITE_APP_ADAPTIVE_BUCKET_POLICY_SERVICE_URL
    public static axios: any

    public static init (axiosInstance: any) {
      AdaptiveBucketPolicyService.axios = axiosInstance
    }

    public static get_bucket_config(bucket_name: string) {
      return AdaptiveBucketPolicyService.axios.get(`${AdaptiveBucketPolicyService.base_url}/bucket/config/${bucket_name}`)
    }

    public static get_bucket_config_audit_events(bucket_name: string) {
      return AdaptiveBucketPolicyService.axios.get(`${AdaptiveBucketPolicyService.base_url}/bucket/config/${bucket_name}/audit_events`)
    }

    public static enable_bucket_config(bucket_name: string) {
      return AdaptiveBucketPolicyService.axios.put(`${AdaptiveBucketPolicyService.base_url}/bucket/config/${bucket_name}/enable`)
    }

    public static disable_bucket_config(bucket_name: string) {
      return AdaptiveBucketPolicyService.axios.put(`${AdaptiveBucketPolicyService.base_url}/bucket/config/${bucket_name}/disable`)
    }

    public static create_bucket_config(config: any) {
      return AdaptiveBucketPolicyService.axios.post(`${AdaptiveBucketPolicyService.base_url}/bucket/config/`, config)
    }

    public static update_bucket_config(config: any) {
      return AdaptiveBucketPolicyService.axios.put(`${AdaptiveBucketPolicyService.base_url}/bucket/config/`, config)
    }

    public static delete_bucket_config(bucket_name: string) {
      return AdaptiveBucketPolicyService.axios.delete(`${AdaptiveBucketPolicyService.base_url}/bucket/config/${bucket_name}`)
    }

    public static evaluate_policy(bucket_name: string, dry_run: boolean) {
      let url_params = {}
      if(dry_run) url_params['dry_run'] = 1
      return AdaptiveBucketPolicyService.axios.get(`${AdaptiveBucketPolicyService.base_url}/bucket/config/${bucket_name}/run`, {params: url_params})
    }

    public static get_policy_facts(bucket_name: string) {
      return AdaptiveBucketPolicyService.axios.get(`${AdaptiveBucketPolicyService.base_url}/bucket/config/${bucket_name}/facts`)
    }

    public static list_policy_evaluations(bucket_name: string) {
      return AdaptiveBucketPolicyService.axios.get(`${AdaptiveBucketPolicyService.base_url}/bucket/config/${bucket_name}/evaluations`)
    }

}

export default AdaptiveBucketPolicyService
